import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { isThenable } from './is.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var STATE_PENDING = 0;
var STATE_RESOLVED = 1;
var STATE_REJECTED = 2;

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(function (resolve) {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise(function (_, reject) {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /*#__PURE__*/function () {
  function SyncPromise(executor) {
    _classCallCheck(this, SyncPromise);
    this._state = STATE_PENDING;
    this._handlers = [];
    this._runExecutor(executor);
  }

  /** @inheritdoc */
  return _createClass(SyncPromise, [{
    key: "then",
    value: function then(onfulfilled, onrejected) {
      var _this = this;
      return new SyncPromise(function (resolve, reject) {
        _this._handlers.push([false, function (result) {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result);
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        }, function (reason) {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        }]);
        _this._executeHandlers();
      });
    }

    /** @inheritdoc */
  }, {
    key: "catch",
    value: function _catch(onrejected) {
      return this.then(function (val) {
        return val;
      }, onrejected);
    }

    /** @inheritdoc */
  }, {
    key: "finally",
    value: function _finally(onfinally) {
      var _this2 = this;
      return new SyncPromise(function (resolve, reject) {
        var val;
        var isRejected;
        return _this2.then(function (value) {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        }, function (reason) {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        }).then(function () {
          if (isRejected) {
            reject(val);
            return;
          }
          resolve(val);
        });
      });
    }

    /** Excute the resolve/reject handlers. */
  }, {
    key: "_executeHandlers",
    value: function _executeHandlers() {
      var _this3 = this;
      if (this._state === STATE_PENDING) {
        return;
      }
      var cachedHandlers = this._handlers.slice();
      this._handlers = [];
      cachedHandlers.forEach(function (handler) {
        if (handler[0]) {
          return;
        }
        if (_this3._state === STATE_RESOLVED) {
          handler[1](_this3._value);
        }
        if (_this3._state === STATE_REJECTED) {
          handler[2](_this3._value);
        }
        handler[0] = true;
      });
    }

    /** Run the executor for the SyncPromise. */
  }, {
    key: "_runExecutor",
    value: function _runExecutor(executor) {
      var _this4 = this;
      var setResult = function setResult(state, value) {
        if (_this4._state !== STATE_PENDING) {
          return;
        }
        if (isThenable(value)) {
          void value.then(resolve, reject);
          return;
        }
        _this4._state = state;
        _this4._value = value;
        _this4._executeHandlers();
      };
      var resolve = function resolve(value) {
        setResult(STATE_RESOLVED, value);
      };
      var reject = function reject(reason) {
        setResult(STATE_REJECTED, reason);
      };
      try {
        executor(resolve, reject);
      } catch (e) {
        reject(e);
      }
    }
  }]);
}();
export { SyncPromise, rejectedSyncPromise, resolvedSyncPromise };